import { Navigate, useLocation } from 'react-router';

const RedirectToLogin = () => {
  const location = useLocation();

  return (
    <Navigate
      replace
      state={{ returnTo: location.pathname + location.search }}
      to="/login"
    />
  );
};

export default RedirectToLogin;
